import {
  Typography,
} from '@material-ui/core/';
import React, {
  Component,
} from 'react';
import NavigationTabs from '../../components/Tabs';
import {
  translate,
} from '../../helperFunctions/translation';
import HistoryFeaturedArticles from './historyArticlesComponent';
import LiveFeaturedArticles from './liveArticlesComponent';

class FeaturedArticlesManagement extends Component {
  tabsLabels: string[] = [translate('FeaturedArticlesLiveTabTitle', {
  }), translate('FeaturedArticlesHistoryTabTitle', {
  })];

  render() {
    return (
      <div>
        <Typography variant="h6" gutterBottom>
          {translate('featuredArticlesPageTitle', {
          })}
        </Typography>
        <NavigationTabs
          tabLabels={this.tabsLabels}
          selected={0}
        >
          <LiveFeaturedArticles />
          <HistoryFeaturedArticles />

        </NavigationTabs>
      </div>
    );
  }
}

export default FeaturedArticlesManagement;
